var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"preloader","show":_vm.show}},[_c('div',{attrs:{"id":"inner"}})])}
var staticRenderFns = []

export { render, staticRenderFns }